<template>
  <div class="content">

    <div class="hero hero--big">
      <div class="hero__contents wrapper">
        <div class="titles">
          <h3 class="titles__subtitle">Hi, I am Noé.</h3>
          <h2 class="titles__title">
            <div>
              <span>An eclectic digital designer</span> <br/>
            </div>
            <div>
              <span>who wants to make digital work</span> <br/>
            </div>
            <div>
              <span class="framed">for good</span>
            </div>
          </h2>
        </div>
        <span class="hero__scroll-indicator" v-on:click="scrollToProjects">
          <span>My projects</span>
        </span>
      </div>
    </div>

    <section class="projects">

      <router-link 
        v-for="p in projects" 
        :to="{name: 'Project', params: {slug: p.slug}}" 
        :title="'View '+p.name"  
        :key="p.name" 
        :class="'projects__item project__' + p.slug"
      >
        <div class="titles wrapper">
          <h3 class="titles__subtitle">{{ p.name}}</h3>
          <h2 class="titles__title">
            {{ p.prefix }} <br/>
            <span v-if="!p.notforgood" class="framed">for good <br/></span>
            {{ p.suffix }}
          </h2>
          <span class="view-btn">View project</span>
        </div>
      </router-link>

    </section>

    <contact theme="white"/>

  </div>
</template>

<script>

import Projects from '@/assets/contents/projects.json';
import Contact from '@/components/_Contact.vue';
import ProjectHero from '@/components/_ProjectHero.vue';

export default {
  name: 'Index',
  data () {
    return {
      projects: Projects,
      hover: false
    }
  },
  methods: {
    scrollToProjects: () => {
      const destination = window.innerHeight
      const distance = destination - window.scrollY
      function step() {
        let progress = (destination - window.scrollY)/distance;
        let amount = Math.ceil(Math.sin(progress*Math.PI)*50)
        window.scrollTo(0, window.scrollY + amount)
        if (window.scrollY < destination) {
          requestAnimationFrame(step);
        }
      }
      requestAnimationFrame(step);
    }
  },
  components: {
    Contact,
    ProjectHero
  },
  mounted () {
  },
  created() {
    /** Change page theme:  */
    let computedStyles = document.styleSheets[0];
      computedStyles.addRule('body', `color: black;`);
      computedStyles.addRule('body', `background: white;`);

      computedStyles.addRule('.header', `color: black;`);
      computedStyles.addRule('.header .btn', `background: white;`);
      computedStyles.addRule('.header .btn::before', `background: lime;`);

      computedStyles.addRule('.hero', `color: black;`);
      computedStyles.addRule('.hero', `background: white;`);

    Object.values(this.projects).forEach(_p => {
      computedStyles.addRule(`.project__${ _p.slug }:hover`, `color: ${_p.textColor};`);
      computedStyles.addRule(`.project__${ _p.slug }:hover`, `background: ${_p.bgColor};`);
      // computedStyles += `.project__${ _p.slug }:hover { 
      //   color: ${_p.textColor}; 
      //   background: ${_p.bgColor};
      // }`;
    });
    
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Index.vue